import { render, staticRenderFns } from "./ComboboxUsers.vue?vue&type=template&id=5d3efe54"
import script from "./ComboboxUsers.vue?vue&type=script&lang=js"
export * from "./ComboboxUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports